import { getKeyValue, Spinner, Tab, Table, TableBody, TableCell, TableColumn, TableHeader, TableRow, Tabs } from "@nextui-org/react"
import { NewJob } from "./newJob"
import { useAuth, useFirestore } from "reactfire";
import { collection, onSnapshot, orderBy, query, where } from "firebase/firestore";
import { useEffect, useState } from "react";
import { PDFViewer } from "../../components/pdfViewer";
import JsonView from "@uiw/react-json-view";
import Chat from "./jobchat";
import TiffViewer from "../../components/tiffViewer";
import { FileType } from "../../types/types";

export const JobManger = () => {

    const auth = useAuth();
    const firestore = useFirestore();
    const [isLoading, setIsLoading] = useState(false);
    const [selectedJob, setSelectedJob] = useState<any>(null);
    const [jobs, setJobs] = useState<Array<any>>();

    const dateFormatter = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    });

    useEffect(() => {
        const fetchData = async () => {

            if (auth.currentUser) {
                const q = query(collection(firestore, "jobs"), where("createdBy", "==", auth.currentUser?.uid), orderBy('updatedAt', 'desc'));

                const unsubscribe = onSnapshot(q, (querySnapshot) => {
                    const docs: Array<any> = [];
                    querySnapshot.forEach((doc) => {
                        docs.push({ ...doc.data(), id: doc.id });
                    });
                    setJobs(docs);
                });
            }
        }
        fetchData();
    }, []);

    const _showInputFile = (file: FileType) => {
        console.log(file.name)
        if (file.name.toLowerCase().endsWith("pdf")) {
            return <PDFViewer filePath={file.path} />
        }
        if (file.name.toLowerCase().endsWith("tiff") || file.name.toLowerCase().endsWith("tif")) {
            return <TiffViewer filePath={file.path} />
        }
        return <></>
    }
    const _showResult = () => {
        if (!selectedJob) {
            return (<div className="flex mt-5 justify-between">
                <div className="flex flex-col">
                    <span className="text-sm">No Job Selected</span>
                </div>
            </div>);
        }

        if (selectedJob.status !== "completed" || !selectedJob.result) {
            return (
                <div className="flex mt-5 justify-between">
                    <div className="flex flex-col">
                        <span className="text-sm">Job is not completed yet</span>
                    </div>
                </div>);
        }

        if (selectedJob.type === "kbase") {
            return (
                <></>
            )
        }
        if (selectedJob.type === "extractor") {
            return (
                <div className="flex mt-5 justify-between">
                    <div className="flex flex-col">
                        <div className="text-sm">Extractor Job</div>
                        <Tabs key="preview" variant="underlined">
                            <Tab key="input" title="input">
                                <PDFViewer filePath={selectedJob.file.path} />
                            </Tab>
                            <Tab key="output" title="output">
                                <JsonView value={selectedJob.result} />
                            </Tab>
                        </Tabs>
                    </div>
                </div>
            )
        }

        if (selectedJob.type === "generator") {
            return (
                <div className="flex mt-5 justify-between">
                    <div className="flex flex-col">
                        <div className="text-sm">Generator Job</div>
                        <Tabs key="preview" variant="underlined">
                            <Tab key="input" title="input">
                                {_showInputFile(selectedJob.file)}
                            </Tab>
                            {selectedJob.result.outputFile !== null ? (
                                <Tab key="output" title="output">
                                    <PDFViewer filePath={selectedJob.result.outputFile?.path} />
                                </Tab>
                            ) : (
                                <></>
                            )}
                            {'doxRailsFile' in selectedJob.result ? (
                                <Tab key="doxrails" title="DoxRails">
                                    <PDFViewer filePath={selectedJob.result.doxRailsFile?.path} />
                                </Tab>
                            ) : (
                                <></>
                            )}

                        </Tabs>
                    </div>
                </div>
            )
        }
    }

    return (
        <div className="">
            <div className="flex flex-row items-end justify-between">
                <div className="text-2xl mb-2 font-bold Page-header">Workbench</div>
            </div>
            <div className="flex w-full min-h-[80vh] max-h-[75vh] border-1 border-s-fuchsia-100">

                <div className="grid grid-cols-6 w-full">
                    <div className="flex-1 p-4 bg-base-100 col-span-2">
                        <div className="mt-2 justify-between flex flex-row">
                            <div className="flex flex-col">
                                <div className="text-lg font-bold">Jobs</div>
                                <span className="text-sm">Ongoing jobs</span>
                            </div>
                            <NewJob />

                        </div>
                        <div className="flex mt-2 overflow-y-auto">
                            {jobs && (
                                <Table
                                    aria-label="Jobs"
                                    classNames={{
                                        table: "h-full",
                                    }}
                                    isHeaderSticky
                                    removeWrapper
                                    selectionMode="single"
                                    color="success"
                                    onSelectionChange={(keys) => {

                                        const jobids = new Set(keys);
                                        const job = jobs.find((job: any) => job.id === jobids.values().next().value);
                                        setSelectedJob(job)
                                    }}
                                >
                                    <TableHeader>
                                        <TableColumn key="name">
                                            Name
                                        </TableColumn>
                                        <TableColumn key="type" allowsSorting>
                                            Type
                                        </TableColumn>
                                        <TableColumn key="status" allowsSorting>
                                            Status
                                        </TableColumn>
                                        <TableColumn key="createdAt" allowsSorting>
                                            Created At
                                        </TableColumn>
                                    </TableHeader>
                                    <TableBody
                                        items={jobs}
                                        isLoading={isLoading}
                                        loadingContent={<Spinner label="Loading..." />}
                                    >
                                        {(item) => {
                                            var formattedDate = dateFormatter.format(item.createdAt.toDate());
                                            return (
                                                <TableRow key={item.id}>
                                                    <TableCell>{getKeyValue(item, 'name')}</TableCell>
                                                    <TableCell>{getKeyValue(item, 'type')}</TableCell>
                                                    <TableCell>{getKeyValue(item, 'status')}</TableCell>
                                                    <TableCell>{formattedDate}</TableCell>
                                                </TableRow>
                                            )
                                        }
                                        }
                                    </TableBody>
                                </Table>
                            )}
                        </div>
                    </div>
                    <div className="flex-1 p-4 bg-base-100 col-span-2">
                        <div className="mt-2">
                            <div className="text-lg font-bold">Job Details</div>
                            <span className="text-sm">Select a job to see details</span>
                        </div>
                        <div className="overflow-y-auto max-h-[70vh]">
                            {_showResult()}
                        </div>
                    </div>
                    <div className="flex-1 p-4 bg-base-100 col-span-2 ">
                        <div className="mt-2">
                            <div className="text-lg font-bold">Explore via Chat</div>
                            <span className="text-sm">Select a document to chat with DoxPro.AI agent</span>
                        </div>
                        {selectedJob ? (
                            <Chat jobId={selectedJob.id} />
                        ) : <></>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}